import Noty from 'noty'

export default {
  success(message) {
    new Noty({
      theme: 'sunset',
      timeout: 2000,
      type: 'success',
      layout: 'topRight',
      text: message
    }).show();
  },
  warning(message) {
    new Noty({
      theme: 'sunset',
      timeout: 3000,
      type: 'warning',
      layout: 'topRight',
      text: message
    }).show();
  },
  error(message) {
    new Noty({
      theme: 'sunset',
      timeout: 5000,
      type: 'error',
      layout: 'topRight',
      text: message
    }).show();
  }
}



// WEBPACK FOOTER //
// ./src/services/noty.service.js